/** Neutral image shown for a category that has no image (served by the app itself). */
export const CATEGORY_PLACEHOLDER = "/assets/img/categories/placeholder.svg";
